<div class="heroContainer">
  <div class="heroWrapper">
    <video
      [autoplay]="true"
      [loop]="true"
      [muted]="true"
      playsinline
      webkit-playsinline
      class="hero_video"
      title="Virsa Performing Arts and Digital Learning Showcase"
    >
      <source
        src="https://d2abnqj5vuy2s4.cloudfront.net/hero_video.mp4"
        type="video/mp4"
        load="lazy"
      />
    </video>
    <img
      loading="lazy"
      src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/hero_backdrop.png"
      alt="Virsa Digital Learning Hub Backdrop"
      class="hero_backdrop"
    />
    <div class="heroDescription">
      <div class="descriptionWrapper">
        <div class="text-center">
          <h1 class="headingWL title">Live Your <span>Dreams</span>!</h1>
          <div class="subtitle">
            With India’s Best Performing Arts Platform.
          </div>
          <div
            class="btnGlobal--secondary heroBtn"
            routerLink="/form/book-sessions-form"
          >
            Book your free session
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
